// components/Carousel.js
import React from 'react';
import '../styles/Carousel.css';

function Carousel() {
  const images = [
    '/images/1.jpeg',
    '/images/2.jpeg',
    '/images/3.jpeg',
    '/images/4.jpeg',
    '/images/5.jpeg',
    '/images/6.jpeg',
    '/images/7.jpeg',
    '/images/8.jpeg',
    '/images/9.jpeg',
    '/images/10.jpeg'
  ];

  // CrÃ©er un tableau avec les images rÃ©pÃ©tÃ©es 3 fois
  const repeatedImages = [...images, ...images, ...images];

  return (
    <div className="carousel-container">
       <div className="carousel-track">
         {/* Premier ensemble d'images */}
         {images.map((image, index) => (
           <div key={`first-${index}`} className="carousel-slide">
             <img src={image} alt={`Slide ${index + 1}`} />
           </div>
         ))}
         {/* Duplication pour l'effet infini */}
         {images.map((image, index) => (
           <div key={`second-${index}`} className="carousel-slide">
             <img src={image} alt={`Slide ${index + 1}`} />
           </div>
         ))}
       </div>
     </div>
  );
}

export default Carousel;
